



























































import SimpleMap from '../../core/components/SimpleMap.vue';
import InputFile from '../../core/components/InputFile.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getIdsFromList
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    MultipleSelect,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        Loading,
        SimpleMap,
        InputFile,
        Combobox,
        MultipleSelect,
        Button,
    }
})
export default class ModalLoadCalibrations extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    harvestRV: boolean = false;
    fileSelected: any = [];
    harvestSelected: any = [];
    fileContent: any = null;
    fileLoaded: boolean = false;

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    selectedFile(file) {
        this.fileSelected = file;
    }

    uploadFile() {
        let reader = new FileReader();
        let self = this;
        this.fileContent = null;
        this.fileLoaded = false;
        this.fileContent = this.fileSelected[0];
        reader.readAsText(this.fileSelected[0]);
        reader.onload = (e: any) => {
            self.fileLoaded = true;
        };
    }
    clearFile() {
        // console.log('clear file');
    }

    loadCalibrations() {
        this.showLoadingDialog('Cargando archivo...');
        //  <br> <small>(Ésta acción puede tomar unos minutos)</small>
        InsuranceServices.postFarmingAppSheet(this.getData)
            .then(res => {
                let msg = res['message'] !== undefined ? res['message'] : 'Archivo subido con éxito';
                this.showSuccessLoadingDialog(res, msg);
                this.reloadMachineView();
            })
            .catch(err => {
                this.showCatchLoadingDialog(err, 'Ocurrio un error');
            });
    }

    get getData() {
        let form_data = new FormData();
        form_data.append('file', this.fileContent);
        // for (let pair of form_data.entries()) {
        //     // console.log(pair[0] + ', ' + pair[1]);
        // }
        return form_data;
    }

    get formIsValid() {
        if (this.fileContent == null) {
            return false;
        }
        return true;
    }

    @Emit()
    closeModal() {}

    @Emit()
    reloadMachineView() {}

    mounted() {}
}
